import { defineNuxtPlugin } from "#app";
import posthog from "posthog-js";
export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  // Check if PostHog token exists before initialization
  if (!runtimeConfig.public.posthogPublicKey) {
    console.log(
      "PostHog token is missing. Please check your environment configuration.",
      runtimeConfig.public.posthogPublicKey
    );
    console.error(
      "PostHog token is missing. Please check your environment configuration."
    );

    // Return a dummy posthog instance to prevent errors
    return {
      provide: {
        posthog: () => ({
          capture: () => {},
          identify: () => {},
          // Add other methods you might use as empty functions
        }),
      },
    };
  }

  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost || "https://app.posthog.com",
    person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
    capture_pageview: false, // we add manual pageview capturing below
    loaded: (posthog) => {
      // if (import.meta.env.MODE === "development") posthog.debug();
    },
  });

  // Make sure that pageviews are captured with each route change
  const router = useRouter();

  router.afterEach((to) => {
    nextTick(() => {
      posthog.capture("$pageview", {
        current_url: to.fullPath,
      });
    });
  });

  console.log("PostHog config:", {
    posthogPublicKey: runtimeConfig.public.posthogPublicKey,
    posthogHost: runtimeConfig.public.posthogHost,
  });

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});
